import { useMemo } from 'react'

import { NotificationVerb } from 'src/shared/schemas/notifications'

type TeamInvitationTitleProps = {
  consumerName: string
  referredByName: string
  referredToName: string
  notificationVerb: NotificationVerb | null
}

const TeamInvitationTitle = ({
  consumerName = 'Client',
  referredByName = 'Someone',
  referredToName = 'Professional',
  notificationVerb,
}: TeamInvitationTitleProps) => {
  const text = useMemo(() => {
    if (!notificationVerb) {
      return 'Team invitation'
    }
    if (notificationVerb === NotificationVerb.TEAM_INVITATION_SENT) {
      return `${referredByName} invited you to join their team`
    } else if (notificationVerb === NotificationVerb.TEAM_INVITATION_INTERESTED) {
      return `${referredToName} is interested in joining your team`
    } else if (notificationVerb === NotificationVerb.TEAM_INVITATION_APPROVED) {
      return `${consumerName} approved ${referredToName} to join the team`
    } else if (notificationVerb === NotificationVerb.TEAM_INVITATION_DECLINED_BY_INVITEE) {
      return `${referredToName} has declined your team invitation`
    } else if (notificationVerb === NotificationVerb.TEAM_INVITATION_DECLINED_BY_CONSUMER) {
      return `${consumerName} declined ${referredToName} from joining`
    } else if (notificationVerb === NotificationVerb.TEAM_INVITATION_EXPIRED) {
      return `Team invitation to ${referredToName} has expired`
    } else if (notificationVerb === NotificationVerb.TEAM_INVITATION_AUTO_REJECTED) {
      return `${referredToName} has been auto-rejected from the team`
    }
    return null
  }, [notificationVerb, referredByName, referredToName, consumerName])

  return <p className="text-[13px] font-medium leading-[18px] text-primary">{text}</p>
}

export default TeamInvitationTitle
